import Paper from '@mui/material/Paper';
import type { Card } from '../../../features/cards/types/Card';
import {useReportCardClickMutation} from '../../../features/cards/api/cards-api';

interface Props {
    card: Card;
}

export const CardsBoardItem = ({card}: Props) => {
    const [
        reportCardClick
    ] = useReportCardClickMutation();
    const audio = new Audio(card.audio);
    const clickHandler = () => {
        audio.play();
        void reportCardClick({ id: card.id });
    };
    return <Paper elevation={3} key={card.id} onClick={clickHandler}>
        <img
            src={card.url}
            alt={card.name}
            style={{maxWidth: '100%',maxHeight: '100%'}}
        />
    </Paper>;

}


export default CardsBoardItem;